import { isEmpty } from 'lodash'

// Subscription status API enums
const SUBSCRIPTION_STATUS = {
  CANCEL_REQUESTED: 'CANCEL_REQUESTED',
  SUBSCRIBED: 'SUBSCRIBED',
  UNSUBSCRIBED: 'UNSUBSCRIBED',
}

const isTrial = subscription =>
  !subscription?.previousPaymentDate && !subscription?.lastUnsuccessfulPaymentDate
const isFirstSignup = subscription => isEmpty(subscription?.status)

export const SUBSCRIPTION_STATE = {
  EVERGREEN_ACTIVE: 'EVERGREEN_ACTIVE',
  EVERGREEN_UNSUBSCRIBED: 'EVERGREEN_UNSUBSCRIBED',
  EVERGREEN_UNSUBSCRIBED_ACTIVE: 'EVERGREEN_UNSUBSCRIBED_ACTIVE',
  TRIAL_ACTIVE: 'TRIAL_ACTIVE',
  TRIAL_UNSUBSCRIBED: 'TRIAL_UNSUBSCRIBED',
  TRIAL_UNSUBSCRIBED_ACTIVE: 'TRIAL_UNSUBSCRIBED_ACTIVE',
}

export const getSubscriptionState = subscription => {
  switch (subscription?.status) {
    case SUBSCRIPTION_STATUS.SUBSCRIBED:
      if (isTrial(subscription)) return SUBSCRIPTION_STATE.TRIAL_ACTIVE
      else return SUBSCRIPTION_STATE.EVERGREEN_ACTIVE
    case SUBSCRIPTION_STATUS.UNSUBSCRIBED:
      if (isTrial(subscription) && isFirstSignup(subscription))
        return SUBSCRIPTION_STATE.TRIAL_UNSUBSCRIBED
      else return SUBSCRIPTION_STATE.EVERGREEN_UNSUBSCRIBED
    case SUBSCRIPTION_STATUS.CANCEL_REQUESTED:
      if (isTrial(subscription)) return SUBSCRIPTION_STATE.TRIAL_UNSUBSCRIBED_ACTIVE
      else return SUBSCRIPTION_STATE.EVERGREEN_UNSUBSCRIBED_ACTIVE
    default:
      return undefined
  }
}
